import React from 'react'

export const useContentIsOpen = (
  isOpen: boolean | undefined
): [isOpen: boolean, onOpen: () => void, onClose: () => void] => {
  const [counter, setCounter] = React.useState(0)
  const isOpenOrContentIsOpen = React.useMemo(
    () => isOpen || counter > 0,
    [counter, isOpen]
  )
  const onOpen = React.useCallback(() => {
    setCounter(value => value + 1)
  }, [])
  const onClose = React.useCallback(() => {
    setCounter(value => value - 1)
  }, [])
  return [isOpenOrContentIsOpen, onOpen, onClose]
}
